(function () {
    'use strict';

    angular
        .module('app.tasks')
        .controller('TaskDetailController', TaskDetailController);

    TaskDetailController.$inject = [
        '$state', '$stateParams',
        'bootstrap.dialog', 'common', 'dataservice', '$window'
    ];

    function TaskDetailController($state, $stateParams, bsDialog, common, dataservice, $window) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;
        vm.isNew = isNew;
        vm.openDatePicker = openDatePicker;
        vm.usersInDepartments = [];
        vm.allUsers = [];
        vm.templates = [];
        vm.dpStatus = {
            displayOnOpen: false,
        }
        vm.datePickerOptions = {
            showWeeks: false,
            ngModelOptions: {
                allowInvalid: false
            }
        };
        vm.departments = [];
        vm.departmentChange = departmentChange;
        vm.templateChange = templateChange;
        vm.selectedTemplate = null;
        
 
        activate();

        function activate() {
            var promises = [getItem()];
            return common.$q.all(promises).then(function (data) {
                departmentChange();
            }, function (error) {  });
            
        }

        function openDatePicker($event) {
            vm.dpStatus.displayOnOpen = true;
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            if ($stateParams.fromDailySetup) {
                $state.go("dailysetup");
            }
            else {
                if ($stateParams.fromDisplay) {
                    $state.go("tasks.display");
                }
                else {
                    $state.go("tasks.list");
                }
            }
            
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Task')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/Tasks/" + vm.item.ID).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function isNew() {
            var val = $stateParams.id; 
            return val === "0";
        }


        function templateChange() {
            if (vm.selectedTemplate) {
                for (var i = 0; i < vm.templates.length; i++) {
                    var t = vm.templates[i];
                    if (vm.selectedTemplate === t.UId) {
                        if (vm.item.Description) {
                            vm.item.Description += "\n" + t.Description;
                        }
                        else {
                            vm.item.Description = t.Description;
                        }
                        
                        vm.item.DepartmentIds = t.DepartmentIds;
                        vm.item.StartAtDisplay = moment(t.StartAtDisplay.substr(0, 16)).toDate();
                        if (t.FinishByDisplay !== null) {
                            vm.item.IncludeFinishBy = 1;
                            vm.item.FinishByDisplay = moment(t.FinishByDisplay.substr(0, 16)).toDate();
                        }
                       
                        break;
                    }
                }
            }
        }

        function getItem() {
            var val = $stateParams.id;
            return dataservice.getItem("api/Tasks/" + val)
                .then(function (response) {
                    if (response) {
                        vm.departments = response.data.departments;
                        vm.allUsers = response.data.usersWithDepartments;
                        vm.templates = response.data.taskTemplates;

                        if (val === '0') {
                            vm.item = {};
                            vm.item.IncludeFinishBy = 0;
                            var d = common.getMainState("mainDate");
                            vm.item.DisplayOn = d;
                            try {
                                var deptIdsAsString = $window.localStorage.getItem("SevenPointTaskDepartmentIds");
                                vm.item.DepartmentIds = [];
                                if (deptIdsAsString) {
                                    try {
                                        var deptIds = deptIdsAsString.split(',');
                                        for (var i = 0; i < deptIds.length; i++) {
                                            for (var j = 0; j < vm.departments.length; j++) {
                                                if (vm.departments[j].ID == deptIds[i]) {
                                                    vm.item.DepartmentIds.push(deptIds[i])
}
}
 
                                        }
                                                                              
                                    }
                                    catch (error) {
                                        console.log(error);
                                        vm.item.DepartmentIds = [];
                                        vm.item.DepartmentIds.push(0);
                                    }
                                }
                                else {
                                    vm.item.DepartmentIds = [];
                                    vm.item.DepartmentIds.push(0);
                                }
                            }
                            catch (error) {
                                console.log(error);
                                vm.item.DepartmentIds = [];
                                vm.item.DepartmentIds.push(0);
                            }
                            
                            vm.item.StartAtDisplay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 6, 0, 0, 0)
                            vm.item.FinishByDisplay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 17, 0, 0, 0);
                            vm.item.AssignedToUserId = 0;
                            vm.item.EmailUserTheyHaveANewTask = 0;
                            vm.item.CreateAsIndividualTasks = 0;
                            vm.item.EndTaskWhenCompleted = 0;
                            common.setAuditInfo(vm.item);
                        }
                        else {
                            vm.item = response.data.item;

                            vm.item.DisplayOn = moment(vm.item.DisplayOn.substr(0, 16)).toDate();
                            vm.item.StartAtDisplay = moment(vm.item.StartAtDisplay.substr(0, 16)).toDate();
                            if (vm.item.FinishByDisplay !== null) {
                                vm.item.IncludeFinishBy = 1;
                                vm.item.FinishByDisplay = moment(vm.item.FinishByDisplay.substr(0, 16)).toDate();
                            }
                            else {
                                vm.item.IncludeFinishBy = 0;
                                var d = new Date();
                                vm.item.FinishByDisplay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 17, 0, 0, 0);
                            }
                            common.setAuditInfo(vm.item);
                            common.convertDateStringsToDates(vm.item);
                        }
                        
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }

        function departmentChange() {
            vm.usersInDepartments = [];
            var addedUserIds = [];
            for (var i = 0; i < vm.allUsers.length; i++) {
                var user = vm.allUsers[i];
                for (var j = 0; j < user.Departments.length; j++) {
                    for (var ii = 0; ii < vm.item.DepartmentIds.length; ii++) {
                        if (vm.item.DepartmentIds[ii] == user.Departments[j]) {
                            if (addedUserIds.indexOf(user.Id) === -1) {
                                addedUserIds.push(user.Id);
                                vm.usersInDepartments.push(user);
                            }
                        }
                    }
                }
            }
        }

        function save() {
            if (vm.item.DepartmentIds.length === 0) {
                common.logger.error("You must select at least one department");
                return;
            }
            
            var fromLocal = common.buildDateTime(vm.item.DisplayOn, vm.item.StartAtDisplay);
            
            if (vm.item.DisplayUntil) {
                var displayFrom = moment(fromLocal);
                var displayUntil = moment(vm.item.DisplayUntil);

                if (displayFrom.isAfter(displayUntil)) {
                    common.logger.error("Display Until must be after Display On");
                    return;
                }


                if (!vm.item.DisplaysOnSunday
                    && !vm.item.DisplaysOnMonday
                    && !vm.item.DisplaysOnTuesday
                    && !vm.item.DisplaysOnWednesday
                    && !vm.item.DisplaysOnThursday
                    && !vm.item.DisplaysOnFriday
                    && !vm.item.DisplaysOnSaturday
                    ) {
                    common.logger.error("Repeating tasks must repeat on a least one day of the week");
                    return;
                }

            }


            if (vm.item.IncludeFinishBy == 1) {
                
                var toLocal = common.buildDateTime(vm.item.DisplayOn, vm.item.FinishByDisplay);
                if (toLocal < fromLocal) {
                    logger.error("Finish By must be after Start At")
                    return;
                }
                vm.item.FinishBy = moment(toLocal).format("HH:mm");
            }
            else {
                vm.item.FinishBy = null;
            }

            vm.item.DisplayOn = moment(fromLocal).format("YYYY-MM-DDT00:00");
            
            vm.item.StartAt = moment(fromLocal).format("HH:mm");
            vm.isSaving = true;
            $window.localStorage.setItem("SevenPointTaskDepartmentIds", vm.item.DepartmentIds.join());
            dataservice.saveItem('api/Tasks', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                common.notifier.notify(common.config.events.taskCountChange);
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });
        }
       
    }
})();
